
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Picker from 'vux/src/components/picker/index.vue'

import DateFormatter from '../../../tools/dateFormatter'
export default{
components: {
PopupPicker,
Popup,
Picker
},
directives: {
TransferDom
},
props: {
defaultSelectAddress: Array,
addressList: Array
},
data() {
return {
show: false,
innerAddressList: [],
selectAddress: [],
selectAddressName: ''
}
},
methods: {
pickerSureBtnClick() {
this.$emit('onClickSureBtn', {
'code': this.selectAddress,
'name': this.selectAddressName
})
this.show = false
},
change(value) {
this.selectAddressName = this.$refs.picker1.getNameValues();
}
},
watch: {
show: function (val, oldVal) {
if (val) {
this.innerAddressList = this.addressList;
}
}
},
mounted() {
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-address-picker.vue